import React from 'react'
import PropTypes from 'prop-types'
import ListItemsNoteOrder from "../../SingleAction/ListItemsNoteOrder"
import { Tag } from 'antd'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'

class OrderTitleCol extends React.PureComponent {
    _mapOrderType = () => {
        const {orderType} = this.props

        if (!orderType) {
            return null
        }

        let output = ""
        switch (orderType) {
            case "FBA":
                output = <span className="label-fba">{orderType}</span>
                break
            case "TIKTOK":
                output = <span className="label-tiktok">{orderType}</span>
                break
            default:
                output = ""
        }

        return output
    }

    render() {
        const {barcodeNumber, orderNumber, packageName, _id, storename, productStatus, orderNote, orderType, fbaWarningLabel, tags, reloadItems} = this.props
        const displayField = productStatus === 'cancelled' ? 'notDisableCancel' : ''
        const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
        const canViewStoreName = checkStoreName()

        return (
            <div className={`OrderNumber ${displayField}`}>
                <div className='text-primary'> #{barcodeNumber}</div>
                <div><small>{packageName || orderNumber}</small></div>
                {canViewStoreName && <div className="text-secondary"><small>{storename || ''}</small></div>}
                <ListItemsNoteOrder key={_id} id={'PopoverNote_' + _id} note={orderNote} itemId={_id} reloadItems={reloadItems}/>
                {this._mapOrderType()}
                <div>
                {
                    fbaWarningLabel==="yes"&&
                    <div className='d-flex pt-2' style={{color:"#f3da35"}}>
                        <span className='label-fba-Warning'>
                            <i className="fa fa-exclamation-triangle" aria-hidden="true" /> Warning label
                        </span>
                    </div>
                }
                </div>

                {
                    isFastProductionTag && <Tag className='mt-2 fastproduction'>Sản xuất nhanh</Tag>
                }
            </div>
        )
    }
}

OrderTitleCol.propTypes = {
    productStatus: PropTypes.string.isRequired,
    barcodeNumber: PropTypes.number,
    orderNumber: PropTypes.string.isRequired,
    packageName: PropTypes.string,
    storename: PropTypes.string,
    _id: PropTypes.string.isRequired,
    note: PropTypes.string,
    orderType: PropTypes.string,
}

export default OrderTitleCol
